import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDemoCards } from '../utils/getDemoCards';
import { getDemoViewMode } from '../utils/getDemoViewMode';

export const fetchDemoCards = createAsyncThunk('FETCH_DEMO_CARDS', async () => {
  return Promise.all([getDemoViewMode(), getDemoCards()]).then((result) => {
    const [demoViewMode, demoCards] = result;

    return {
      demoViewMode,
      demoCards,
    };
  });
});
